import { useState } from "react";

export type StorageEntry = {
	key: string;
};

export default function useStorage(entry: StorageEntry) {
	const [value, setValue] = useState(localStorage.getItem(entry.key));

	function set(newValue: string) {
		localStorage.setItem(entry.key, newValue);
		setValue(newValue);
	}

	function remove() {
		localStorage.removeItem(entry.key);
		setValue(null);
	}

	return { value, set, remove };
}
